import { getToken } from "../../api/api_auth"
import { DebugManager } from "../jsx/DebugManager"
import Cookies from "universal-cookie"

let dbMgrActivate = false

export const REACT_APP_API_URL = process.env.REACT_APP_API_URL

console.log("REACT_APP_API_URL", REACT_APP_API_URL)

export function createUrl(url, parameters, defaultParameters = {}) {
  let dbMgr = new DebugManager("ApiCommon")
  dbMgr.activate(dbMgrActivate)
  let debug = dbMgr.debug

  debug("createUrl")
  debug("url:", url)
  debug("parameters:", parameters)
  debug("defaultParameters:", defaultParameters)

  // console.log("createUrl")
  const allParameters = {
    ...defaultParameters,
    ...parameters,
  }

  debug("allParameters:", allParameters)

  let cookies = new Cookies()

  debug("cookies:", cookies)
  let user = cookies.get("gg_user")

  url += "?"

  if (user) {
    url += "lang=" + user.preferredLanguage + "&"
  }
  for (let key in allParameters) {
    debug("allParameters", "key:", key, "allParameters[key]", allParameters[key])

    // ex: {'order': {'name' : 'asc'}}
    if (key === "order") {
      for (let orderField in allParameters[key]) {
        url += "order[" + orderField + "]=" + allParameters[key][orderField] + "&"
      }
    } else if (allParameters[key] instanceof Array) {
      debug("allParameters[key] array:", key, allParameters[key])

      // console.log(allParameters[key])
      for (let arrayField in allParameters[key]) {
        // console.log(arrayField)

        let fieldKey = key
        fieldKey += "[]"

        url += fieldKey + "=" + allParameters[key][arrayField] + "&"
      }
    } else if (typeof allParameters[key] === "object") {
      debug("allParameters[key] object:", key, allParameters[key])

      // console.log(allParameters[key])
      for (let arrayField in allParameters[key]) {
        debug("arrayField :", arrayField, allParameters[key])

        if (key === "exists") {
          url += key + "[" + arrayField + "]=" + allParameters[key][arrayField] + "&"
        } else if (key === "ranges") {
          for (let [rangeOperator, rangeValue] of Object.entries(allParameters[key][arrayField])) {
            debug("ranges :", rangeOperator, rangeValue)
            url += arrayField + "[" + rangeOperator + "]=" + rangeValue + "&"
          }
        } else if (typeof arrayField === "string") {
          url += key + "." + arrayField + "=" + allParameters[key][arrayField] + "&"
        } else {
          url += key + "[]=" + allParameters[key][arrayField] + "&"
        }
      }
    } else {
      url += key + "=" + allParameters[key] + "&"
    }
  }

  url = url.substr(0, url.length - 1)
  debug("return url", url)
  return url
}

export function createUri(url, id) {
  let dbMgr = new DebugManager("ApiCommon")
  dbMgr.activate(dbMgrActivate)
  let debug = dbMgr.debug

  url = url + "/" + parseInt(id)
  debug("createUri", url)

  return url
}

export async function getObjects(url, auth = true) {
  let dbMgr = new DebugManager("ApiCommon")
  dbMgr.activate(dbMgrActivate)
  let debug = dbMgr.debug

  debug("getObjects", url)

  let headers = {}
  if (auth) {
    headers["Authorization"] = "Bearer " + (await getToken())
  }

  return fetch(url, {
    headers: headers,
  })
    .then((response) => {
      // statusCodeManager(response)
      return response.json()
    })
    .catch((error) => {
      console.log("error", error)
      // window.location = "/logout"
    })
}

export async function getObject(url, auth = true) {
  let dbMgr = new DebugManager("ApiCommon")
  dbMgr.activate(dbMgrActivate)
  let debug = dbMgr.debug

  debug("getObject", url, auth)

  let headers = { "Content-Type": "application/ld+json" }
  if (auth) {
    headers["Authorization"] = "Bearer " + (await getToken())
  }

  return fetch(url, {
    headers: headers,
  }).then((response) => {
    return handleResponse(response)
  })
}

export async function putObject(url, putValues = {}) {
  let dbMgr = new DebugManager("ApiCommon")
  dbMgr.activate(dbMgrActivate)
  let debug = dbMgr.debug

  debug("putObject", url, putValues)

  return fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/ld+json",
      Authorization: "Bearer " + (await getToken()),
    },
    body: JSON.stringify(putValues),
  }).then((response) => {
    return handleResponse(response)
  })
}

export async function patchObject(url, patchValues = {}) {
  let dbMgr = new DebugManager("ApiCommon")
  dbMgr.activate(dbMgrActivate)
  let debug = dbMgr.debug

  debug("patchObject", url, patchValues)

  return fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/merge-patch+json",
      Authorization: "Bearer " + (await getToken()),
    },
    body: JSON.stringify(patchValues),
  }).then((response) => {
    return handleResponse(response)
  })
}

export async function postObject(url, postData, auth = true) {
  let dbMgr = new DebugManager("ApiCommon")
  dbMgr.activate(dbMgrActivate)
  let debug = dbMgr.debug

  debug("postObject", url, postData, auth)

  let headers = { "Content-Type": "application/ld+json" }
  if (auth) {
    headers["Authorization"] = "Bearer " + (await getToken())
  }

  return fetch(url, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(postData),
  }).then((response) => {
    if (auth) {
      return handleResponse(response)
    } else {
      return response
    }
  })
}

export async function deleteObject(url) {
  let dbMgr = new DebugManager("ApiCommon")
  dbMgr.activate(dbMgrActivate)
  let debug = dbMgr.debug

  debug("deleteObject", url)

  return fetch(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + (await getToken()),
    },
  }).then((response) => {
    handleResponse(response)
  })
}

export async function getBinaryFile(url, fileName) {
  let dbMgr = new DebugManager("ApiCommon")
  dbMgr.activate(dbMgrActivate)
  let debug = dbMgr.debug

  debug("getBinaryFile", url, fileName)

  const response = await fetch(REACT_APP_API_URL + url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + (await getToken()),
    },
  })

  const objectUrl = window.URL.createObjectURL(await response.blob())
  const link = document.createElement("a")
  link.href = objectUrl
  link.setAttribute("download", fileName)
  document.body.appendChild(link)
  link.click()
  link.parentNode.removeChild(link)
}

export async function handleResponse(response) {
  let dbMgr = new DebugManager("ApiCommon")
  dbMgr.activate(dbMgrActivate)
  let debug = dbMgr.debug

  debug("handleResponse", response.status, response)

  let body
  switch (response.status) {
    case 200:
    case 201:
      return await response.json()
    case 400:
    case 401:
      body = await response.json()
      throw new Error(body["message"])
    case 403:
      throw new Error("HTTP " + response.status + ": " + response.statusText)
    case 422:
      body = await response.json()
      throw new Error(body["hydra:description"])
    case 500:
      throw new Error("HTTP " + response.status + ": " + response.statusText)
    default:
      console.log("Unhandled error in statusCodeManager", response)
      return response
  }
}
